import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CarnivalDetails from './carnivalDetail';
import {
  getCarnivalDetail
} from 'services/redux/brandActivtion/conductCamp/action';

const mapStateToProps = (state) => ({
    carnivalDetail: state.ConductCampReducer.carnivalDetail
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getCarnivalDetail
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CarnivalDetails);
